module.exports = __webpack_public_path__ + "img/play-icon-blue.c1e43c81.svg";